import type { HttpClient } from '../http';
import { unwrap, type ApiEnvelope } from '../envelope';
import type { DashboardSummary, MonthlyRevenuePoint, OnboardingStatus, RevenueHealth, UpcomingInvoice } from '../types/domain';

export function dashboardEndpoints(http: HttpClient) {
  return {
    summary: () => http.get<ApiEnvelope<DashboardSummary>>('/v1/dashboard/summary').then(unwrap),
    upcoming: () => http.get<ApiEnvelope<UpcomingInvoice[]>>('/v1/dashboard/upcoming').then(unwrap),
    health: () => http.get<ApiEnvelope<RevenueHealth>>('/v1/dashboard/health').then(unwrap),
    revenueMonthly: (months = 6) => http.get<ApiEnvelope<MonthlyRevenuePoint[]>>('/v1/dashboard/revenue-monthly', { query: { months } }).then(unwrap),
    onboarding: () => http.get<ApiEnvelope<OnboardingStatus>>('/v1/onboarding').then(unwrap),
  };
}
export type DashboardEndpoints = ReturnType<typeof dashboardEndpoints>;
